class MegaMenuOpener extends HTMLElement {
  constructor() {
    super();
    this.detailsElement = this.querySelector("details");
    this.summaryElement = this.querySelector("summary");
    this.headerElement = this.closest(".header");
    this.headerNavElements = this.headerElement.querySelectorAll(
      "[data-header-nav-item]",
    );
  }

  connectedCallback() {
    // Open menu on hover
    this.summaryElement.addEventListener("mouseenter", (event) => {
      this.closeAll();
      this.open();
    });

    // Close menu on click outside
    document.addEventListener("click", (event) => {
      if (!this.detailsElement.contains(event.target)) {
        this.close();
      }
    });

    // Close menu on mouse leave
    this.headerElement.addEventListener("mouseleave", () => {
      this.close();
    });

    // Close menu when hitting escape
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.close();
      }
    });

    // Close menu when hovering over other menu items
    this.headerNavElements.forEach((navElement) => {
      navElement.addEventListener("mouseenter", (event) => {
        if (!event.target.contains(this)) this.close();
      });
    });
  }

  open() {
    this.detailsElement.open = true;
  }

  close() {
    this.detailsElement.open = false;
  }

  closeAll() {
    const allDetails = this.headerElement.querySelectorAll(
      "mega-menu-opener details",
    );

    allDetails.forEach((details) => {
      details.open = false;
    });
  }
}

if (!customElements.get("mega-menu-opener")) {
  customElements.define("mega-menu-opener", MegaMenuOpener);
}
